export const GET_DATA_BLOG = "@@BLOG/GET";
export const PUT_DATA_BLOG = "@@BLOG/PUT";

export const actionCreators = {
    get: (payload) => ({
        type: GET_DATA_BLOG, 
        payload
    }),
    put: (payload, meta) => ({
        type: PUT_DATA_BLOG,
        payload, 
        meta
    }),
}